import type { InsightsResponse } from '@/shared/api';
import { channelLabel } from './financeChartTheme';

export interface ChannelSlice {
  /** Der Schlüssel vom Server — auch der Wert, mit dem der Belegungsverlauf vergleicht. */
  key: string;
  name: string;
  revenue: number;
  count: number;
  share: number;
}

export function buildChannelSlices(insights: InsightsResponse): ChannelSlice[] {
  const total = Object.values(insights.channelMix.byChannel).reduce(
    (sum, entry) => sum + entry.revenue,
    0,
  );
  return Object.entries(insights.channelMix.byChannel)
    .map(
      ([key, stat]): ChannelSlice => ({
        key,
        name: channelLabel(key),
        revenue: stat.revenue,
        count: stat.bookingCount,
        share: total > 0 ? stat.revenue / total : 0,
      }),
    )
    .sort((a, b) => b.revenue - a.revenue);
}
